<script lang="ts">
import { Field } from 'vee-validate';
import { useId } from 'vue';

import { BuilderComponent } from '@/utils/cms';

interface Props {
  name: string;
  value: string;
}
export const RadioWrapperRegistration: BuilderComponent = {
  name: 'Radio',
  canHaveChildren: true,
  inputs: [
    {
      name: 'name',
      type: 'string',
    },
    {
      name: 'value',
      type: 'string',
    },
  ],
};
</script>

<script setup lang="ts">
defineProps<Props>();

const id = useId();
</script>

<template>
  <div class="flex items-center gap-2">
    <Field :name type="radio" :value v-slot="{ field }">
      <input
        v-bind="field"
        class="w-4 h-4 m-0 align-middle accent-nuts-lime-800 accent-bg-nuts-lime-800"
        :name
        :id
        type="radio"
        :value
      />
      <slot />
    </Field>
  </div>
</template>
